import { css } from '@emotion/react'
import { memo } from 'react'
import {
    IMAGE_CATEGORIES,
    SEARCH_TYPE,
    SORT_BY,
} from '../../../../mfcLogic/api/chatImages'
import i18n from '../../../../utilities/i18n'
import { getThemeSpacing } from '../../../styles/appTheme'
import APP_BREAKPOINTS, { maxWindowWidth } from '../../../styles/breakpoints'
import { palette } from '../../../styles/colors'
import SelectMFC from './SelectMFC'

const rootStyles = css({
    display: 'flex',
    flexFlow: 'row wrap',
    padding: getThemeSpacing(0.5),
    justifyContent: 'space-evenly',
    borderBottom: `1px solid ${palette.drawerDivider}`,
    width: '100%',
    height: 'auto',
    /** shorter when portrait/small viewport */
    // '@media screen and (max-height: 640px)': {
    //     height: 55,
    // },
    [maxWindowWidth(APP_BREAKPOINTS.sm)]: {
        height: 55,
    },
})

const titleStyles = css({
    fontWeight: 'bold' as const,
    fontSize: '0.8125rem',
    padding: getThemeSpacing(0.5),
    width: '100%',
    // paddingBottom: getThemeSpacing(0.75),

    /** hide when portrait/small viewport */
    // '@media screen and (max-height: 640px)': {
    //     display: 'none',
    // },
    [maxWindowWidth(APP_BREAKPOINTS.sm)]: {
        display: 'none',
    },
})

const optionsRenderer = ([key, { label }]) => {
    return (
        <option value={key} key={key}>
            {label}
        </option>
    )
}

interface IBrowseCategories {
    showBrowseCategories: boolean
    onSelectCategory(category: string): void
    onSelectSortBy(sortBy: string): void
    onSelectSearchType(searchType: string): void
    onSelectSortSearchBy(sortBy: string): void
    selectedCategory: string
    sortCategoryBy: string
    searchType: string
    sortSearchBy: string
}

const BrowseCategories = memo((props: IBrowseCategories) => {
    const {
        showBrowseCategories = true,
        onSelectCategory,
        onSelectSortBy,
        onSelectSearchType,
        onSelectSortSearchBy,
        selectedCategory,
        sortCategoryBy,
        searchType,
        sortSearchBy,
    } = props

    return (
        <div css={rootStyles}>
            {showBrowseCategories ? (
                <>
                    <div css={titleStyles}>Browse Categories:</div>
                    <SelectMFC
                        value={selectedCategory}
                        inputLabel={i18n.t('chatImages.category')}
                        selectOptions={IMAGE_CATEGORIES}
                        onSelect={onSelectCategory}
                        optionsRenderer={optionsRenderer}
                    />
                    <SelectMFC
                        styleOverrides={{ paddingBottom: getThemeSpacing(1) }}
                        value={sortCategoryBy}
                        inputLabel={i18n.t('chatImages.sortBy')}
                        selectOptions={SORT_BY}
                        onSelect={onSelectSortBy}
                        optionsRenderer={optionsRenderer}
                        disabled={selectedCategory === 'recentlyUsed'}
                    />
                </>
            ) : (
                <>
                    <div css={titleStyles}>Search filters:</div>
                    <SelectMFC
                        value={searchType}
                        inputLabel={i18n.t('chatImages.searchType')}
                        selectOptions={SEARCH_TYPE}
                        onSelect={onSelectSearchType}
                        optionsRenderer={optionsRenderer}
                    />
                    <SelectMFC
                        styleOverrides={{ paddingBottom: getThemeSpacing(1) }}
                        value={sortSearchBy}
                        inputLabel={i18n.t('chatImages.sortBy')}
                        selectOptions={SORT_BY}
                        onSelect={onSelectSortSearchBy}
                        optionsRenderer={optionsRenderer}
                    />
                </>
            )}
        </div>
    )
})

export default BrowseCategories
